module.exports = __webpack_public_path__ + "static/aurorejeremie-89dd6b83e5122854b5262b343db7300d.png";